// import React, { useEffect, useState } from 'react';
// import Grid from '@mui/material/Grid';
// import Box from '@mui/material/Box';
// import TextField from '@mui/material/TextField';
// import Button from '@mui/material/Button';
// import IconButton from '@mui/material/IconButton';
// import Card from '@mui/material/Card';
// import Tooltip from '@mui/material/Tooltip';
// import CardContent from '@mui/material/CardContent';
// import Typography from '@mui/material/Typography';
// import ThumbUpIcon from '@mui/icons-material/ThumbUp';
// import EditIcon from '@mui/icons-material/Edit';
// import DeleteIcon from '@mui/icons-material/Delete';
// import Dialog from '@mui/material/Dialog';
// import DialogActions from '@mui/material/DialogActions';
// import PersonIcon from "@mui/icons-material/Person";
// import DialogContentText from '@mui/material/DialogContentText';
// import DialogTitle from '@mui/material/DialogTitle';
// import useMediaQuery from '@mui/material/useMediaQuery';
// import { useTheme } from '@mui/material/styles';
// import Stack from '@mui/material/Stack';
// import { useAddComment, useDeleteComment, useGetAllCommentById } from '../../Hooks';
// import { useSelector } from 'react-redux';
// import LikeIcon from "@mui/icons-material/Favorite";
// import { useGetAllPersonPictureByTenantId } from '../../../AllTenantOkrs/Hooks';
// import { CircularProgress } from '@mui/material';

// // interface Comment {
// //   id: number;
// //   text: string;
// //   likes: number;
// //   isEditing: boolean;
// //   userAvatar: string; // Added for user profile picture
// // }

// const CommentSection: React.FC = () => {
//   const [comments, setComments] = useState<Comment[]>([]);
//   const [newComment, setNewComment] = useState<string>("");

//   const {
//     mutate: addCm,
//     isSuccess,
//     data,
//     isLoading: AddKrLoading,
//   } = useAddComment();
  
//   // const initialAddKeyR = (data: any) => {
//   //   let { pointingSystemType } = data;
//   //   const verticalAlignmentLocal: Array<string> = [];
//   //           verticalAlignmentBaseData.map((group: any) => ({
//   //             ...group,
//   //             items: group.items.map(
//   //               (item: any) => item.checked && verticalAlignmentLocal.push(item.id)
//   //             ),
//   //           }));
//   //   let ids =
//   //     pointingSystemType === "Regularly" ? [{ ...hundredValue }] : idsValue;
//   //   let totalData = {
//   //     ...data,
//   //     tenantId: tenantId,
//   //     objectiveId: objectiveId,
//   //     onValue: "",
//   //     keyResultParentIds: verticalAlignmentLocal,
//   //   };
//   //   totalData.valuesDetailCommandDtos = ids;
//   //   totalData.horizontalAlignments = horizontalAlignments.map(
//   //     ({ value }) => value
//   //   );
//   //   addKeyResulttt(totalData);
//   // };

//   const handleAddComment = () => {
//     if (newComment.trim() === "") return;

//     const comment: any = {
//       //id: comments.length + 1,
//       text: newComment,
//       tenantId : 
//       //likes: 0,
//       //isEditing: false,
//       //userAvatar: `https://i.pravatar.cc/150?img=${comments.length + 1}`, // Random avatar
//     };

//     setComments([...comments, comment]);
//     setNewComment("");
//   };

//   const handleDeleteComment = (id: number) => {
//     setComments(comments.filter((comment) => comment.id !== id));
//   };

//   const handleEditComment = (id: number) => {
//     setComments(
//       comments.map((comment) =>
//         comment.id === id ? { ...comment, isEditing: true } : comment
//       )
//     );
//   };

//   const handleSaveComment = (id: number, newText: string) => {
//     setComments(
//       comments.map((comment) =>
//         comment.id === id ? { ...comment, text: newText, isEditing: false } : comment
//       )
//     );
//   };

//   const handleCancelEdit = (id: number) => {
//     setComments(
//       comments.map((comment) =>
//         comment.id === id ? { ...comment, isEditing: false } : comment
//       )
//     );
//   };

//   const handleLikeComment = (id: number) => {
//     setComments(
//       comments.map((comment) =>
//         comment.id === id ? { ...comment, likes: comment.likes + 1 } : comment
//       )
//     );
//   };

//   return (
//     <Grid container spacing={2} justifyContent="center">
//       <Grid item xs={12} md={8}>
//         <Box
//           sx={{
//             backgroundColor: '#f0f4f8',
//             padding: '16px',
//             borderRadius: '8px',
//             boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)',
//           }}
//         >
//           <Typography variant="h6" gutterBottom>
//             نظرات خود را بنویسید
//           </Typography>
//           <TextField
//             label="نظر خود را وارد کنید"
//             variant="outlined"
//             fullWidth
//             value={newComment}
//             onChange={(e) => setNewComment(e.target.value)}
//             sx={{ mb: 2, backgroundColor: '#fff', borderRadius: '8px' }}
//           />
//           <Button
//             variant="contained"
//             color="primary"
//             onClick={handleAddComment}
//             sx={{
//               backgroundColor: '#1976d2',
//               '&:hover': {
//                 backgroundColor: '#005bb5',
//               },
//             }}
//           >
//             ارسال نظر
//           </Button>
//         </Box>
//       </Grid>
//       <Grid item xs={12} md={8} sx={{ mt: 3 }}>
//         <Box>
//           {comments.length > 0 ? (
//             comments.map((comment) => (
//               <Card
//                 key={comment.id}
//                 sx={{
//                   mb: 2,
//                   transition: 'transform 0.3s ease, box-shadow 0.3s ease',
//                   '&:hover': {
//                     transform: 'translateY(-4px)',
//                     // boxShadow: '0px 6px 18px rgba(0, 0, 0, 0.15)',
//                   },
//                 }}
//               >
//                 <CardContent>
//                   <Stack direction="row" spacing={2} alignItems="center">
//                     {/* <Avatar alt="User Avatar" src={comment.userAvatar} /> */}
//                     {comment.isEditing ? (
//                       <Box display="flex" alignItems="center" flexGrow={1}>
//                         <TextField
//                           fullWidth
//                           defaultValue={comment.text}
//                           onBlur={(e) =>
//                             handleSaveComment(comment.id, e.target.value)
//                           }
//                           sx={{ mr: 2 }}
//                         />
//                         <IconButton onClick={() => handleCancelEdit(comment.id)}>
//                           <CancelIcon />
//                         </IconButton>
//                       </Box>
//                     ) : (
//                       <Box flexGrow={1}>
//                         <Typography variant="body1">{comment.text}</Typography>
//                       </Box>
//                     )}
//                   </Stack>
//                   <Box display="flex" justifyContent="space-between" mt={2}>
//                     {/* <Box>
//                       <IconButton
//                         onClick={() => handleLikeComment(comment.id)}
//                         sx={{ color: '#1976d2' }}
//                       >
//                         <ThumbUpIcon />
//                       </IconButton>
//                       <Typography
//                         variant="caption"
//                         sx={{ marginLeft: '8px', color: '#555' }}
//                       >
//                         {comment.likes} لایک
//                       </Typography>
//                     </Box> */}
//                     <Box>
//                       <IconButton onClick={() => handleEditComment(comment.id)}>
//                         <EditIcon color='primary' />
//                       </IconButton>
//                       <IconButton
//                         onClick={() => handleDeleteComment(comment.id)}
//                         sx={{ color: '#d32f2f' }}
//                       >
//                         <DeleteIcon />
//                       </IconButton>
//                     </Box>
//                   </Box>
//                 </CardContent>
//               </Card>
//             ))
//           ) : (
//             <Typography align="center" color="textSecondary">
//               نظری ثبت نشده است.
//             </Typography>
//           )}
//         </Box>
//       </Grid>
//     </Grid>
//   );
// };

// export default CommentSection;

// interface Comment {
//   commentId: string;
//   tenantId: string;
//   text: string;
//   createBy: string;
//   createDate: string;
//   replies?: Comment[]; // اضافه کردن پاسخ‌ها

//   // likeCount: number;
//   // isEditing: boolean;
//   // userAvatar: string;
// }

// interface CommentSectionProps {
//   id: any;
//   name: any;
//   //commentss : any; // می‌توانید تایپ دقیق‌تری مانند number یا string مشخص کنید
// }

// const CommentSection: React.FC<CommentSectionProps> = ({ id,commentss }) => {
//   const [newComment, setNewComment] = useState<string>("");
//   const [comments, setComments] = useState<any[]>([]);
//   const [activeBtn, setActiveBtn] = useState<string>("none");
//   const [likec, setLikeCount] = useState<number>(/*likeCount*/0);
//   const tenantId=useSelector((state:any)=>state.meetings.profileTenantId);
//   const {
//     mutate: addCm,
//     isSuccess,
//     data,
//     isLoading: AddKrLoading,
//   } = useAddComment();

//   useEffect(() => {
//     if (commentss !== null && commentss !== undefined) {
//       const newComments: any[] = [];
//       commentss.map((item : any) => {
//       newComments.push(item); 
//     });
//       setComments(commentss);
//     }
//   }, [commentss]);
  
//   const initialDisLikeObject = () => {
//     let deleteBody = {
//       objectiveId: id,
//       tenantId: tenantId,
//     };
//     //disLikeObjectve(deleteBody);
//   };

//   const initialLikeObject = () => {
//     let deleteBody = {
//       objectiveId: id,
//       tenantId: tenantId,
//     };
//     //likeObjectve(deleteBody);
//   };

//   const handleReactionClick = (reaction: string): void => {
//     if (activeBtn === "none") {
//       // if (reaction === "dislike") {
//       //   setdisLikeCount(dislikeCount + 1);
//       //   setActiveBtn("disLike");
//       // } else
//       if (reaction === "like") {
//         setLikeCount(likec + 1);
//         setActiveBtn("like");
//         initialLikeObject();
//       }
//     } else if (activeBtn === reaction) {
//       // if (reaction === "dislike") {
//       //   setdisLikeCount(dislikeCount - 1);
//       // } else
//       if (reaction === "like") {
//         setLikeCount(likec - 1);
//         initialDisLikeObject();
//       }
//       setActiveBtn("none");
//     } else if (activeBtn !== reaction) {
//       // if (reaction === "dislike") {
//       //   setdisLikeCount(dislikeCount + 1);
//       //   setLikeCount(likeCount - 1);
//       //   setActiveBtn("dislike");
//       // } else
//       if (reaction === "like") {
//         // setdisLikeCount(dislikeCount + 1);
//         // setdisLikeCount(dislikeCount - 1);
//         setActiveBtn("like");
//       }
//     }
//   };

//   const handleAddComment = () => {
//     if (newComment.trim() === "") return;

//     const comment: Comment = {
//       commentId: id,
//       text: newComment,
//       // likeCount: 0,
//       tenantId:tenantId
//       // isEditing: false,
//       // userAvatar: `https://i.pravatar.cc/150?img=${comments.length + 1}`, // آواتار تصادفی
//     };

//     addCm(comment);
//     setComments([...comments, comment]);
//     setNewComment("");
//   };

//   const handleDeleteComment = (id: string) => {
//     setComments(comments.filter((comment) => comment.id !== id));
//   };



//   // const handleEditComment = (id: string) => {
//   //   setComments(
//   //     comments.map((comment) =>
//   //       comment.id === id ? { ...comment, isEditing: true } : comment
//   //     )
//   //   );
//   // };

//   // const handleSaveComment = (id: string, newText: string) => {
//   //   setComments(
//   //     comments.map((comment) =>
//   //       comment.id === id ? { ...comment, text: newText, isEditing: false } : comment
//   //     )
//   //   );
//   // };

//   // const handleCancelEdit = (id: string) => {
//   //   setComments(
//   //     comments.map((comment) =>
//   //       comment.id === id ? { ...comment, isEditing: false } : comment
//   //     )
//   //   );
//   // };

//   const handleLikeComment = (id: string) => {
//     setComments(
//       comments.map((comment) =>
//         comment.id === id ? { ...comment, likeCount: comment.likeCount + 1 } : comment
//       )
//     );
//   };

//   return (
//     <Grid container spacing={2} justifyContent="center">
//       <Grid item xs={12} md={8}>
//         <Box
//           sx={{
//             backgroundColor: '#f0f4f8',
//             padding: '16px',
//             borderRadius: '8px',
//             boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)',
//           }}
//         >
//           <Typography variant="h6" gutterBottom>
//             نظرات خود را بنویسید
//           </Typography>
//           <TextField
//             label="نظر خود را وارد کنید"
//             variant="outlined"
//             fullWidth
//             value={newComment}
//             onChange={(e) => setNewComment(e.target.value)}
//             sx={{ mb: 2, backgroundColor: '#fff', borderRadius: '8px' }}
//           />
//           <Button
//             variant="contained"
//             color="primary"
//             onClick={handleAddComment}
//             sx={{
//               backgroundColor: '#1976d2',
//               '&:hover': {
//                 backgroundColor: '#005bb5',
//               },
//             }}
//           >
//             ارسال نظر
//           </Button>
//         </Box>
//       </Grid>
//       <Grid item xs={12} md={8} sx={{ mt: 3 }}>
//         <Box>
//           {comments.length > 0 ? (
//             comments.map((comment) => (
//               <Card
//                 key={comment.id}
//                 sx={{
//                   mb: 2,
//                   transition: 'transform 0.3s ease, box-shadow 0.3s ease',
//                   '&:hover': {
//                     transform: 'translateY(-4px)',
//                   },
//                 }}
//               >
//                 <CardContent>
//                   <Stack direction="row" spacing={2} alignItems="center">
//                     {/* <Avatar alt="User Avatar" src={comment.userAvatar} /> */}
//                     {/* {comment.isEditing ? (
//                       <Box display="flex" alignItems="center" flexGrow={1}>
//                         <TextField
//                           fullWidth
//                           defaultValue={comment.text}
//                           onBlur={(e) =>
//                             handleSaveComment(comment.id, e.target.value)
//                           }
//                           sx={{ mr: 2 }}
//                         />
//                         <IconButton onClick={() => handleCancelEdit(comment.id)}>
//                           <CancelIcon />
//                         </IconButton>
//                       </Box>
//                     ) : 
//                     ( */}
//                       <Box flexGrow={1}>
//                         <Typography variant="body1">{comment.text}</Typography>
//                       </Box>
//                     {/* )} */}
//                   </Stack>
//                   {/* <Box display="flex" justifyContent="space-between" mt={2}>
//                     <Box>
//                       <IconButton
//                         onClick={() => handleLikeComment(comment.id)}
//                         sx={{ color: '#1976d2' }}
//                       >
//                         <ThumbUpIcon />
//                       </IconButton>
//                       <Typography
//                         variant="caption"
//                         sx={{ marginLeft: '8px', color: '#555' }}
//                       >
//                         {comment.likeCount} لایک
//                       </Typography>
//                     </Box> */}
//                     <Box> 
//                     <Box display={"flex"} justifyContent={"end"}>
//                         <div className="btnn-container">
//                           <button
//                             className={`btnn ${activeBtn === "like" ? "like-active " : ""}`}
//                             onClick={() => handleReactionClick("like")}
//                           >
//                             <LikeIcon />
//                             {comment.likeCount}
//                           </button>
//                         </div>
//                       </Box>
//                       {/* <IconButton onClick={() => handleEditComment(comment.id)}>
//                         <EditIcon color='primary' />
//                       </IconButton> */}
//                       <IconButton
//                         onClick={() => handleDeleteComment(comment.id)}
//                         sx={{ color: '#d32f2f' }}
//                       >
//                         <DeleteIcon />
//                       </IconButton>
//                     </Box>
//                 </CardContent>
//               </Card>
//             ))
//           ) : (
//             <Typography align="center" color="textSecondary">
//               نظری ثبت نشده است.
//             </Typography>
//           )}
//         </Box>
//       </Grid>
//     </Grid>
//   );
// };

// export default CommentSection;
import React, { useEffect, useState } from 'react';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import Card from '@mui/material/Card';
import Tooltip from '@mui/material/Tooltip';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import PersonIcon from "@mui/icons-material/Person";
import DialogTitle from '@mui/material/DialogTitle';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import Stack from '@mui/material/Stack';
import DYToastMessage from "../../../../components/GlobalComponents/DyToastMessage/DYToastMessage";
import { useAddComment,useEditComment, useDeleteComment, useGetAllCommentById } from '../../Hooks';
import { useSelector } from 'react-redux';
import { useGetAllPersonPictureByTenantId } from '../../../AllTenantOkrs/Hooks';
import { CircularProgress } from '@mui/material';
interface Comment {
  commentId: string;
  tenantId: string;
  text: string;
  createBy: string;
  createDate: string;
  personId: string;
  replies?: Comment[]; 
  parentId?: string; 
  meetingId?: string; 
}
interface CommentSectionProps {
  id: any;
  name: any;
  meetingId?: string;
}
const CommentSection: React.FC<CommentSectionProps> = ({ id, name, meetingId }) => {
  const [newComment, setNewComment] = useState<string>("");
  const [comments, setComments] = useState<any[]>([]);
  const [isSucces, SetIsSuccess] = useState<boolean>();
  const [tMessage, SetTMessage] = useState<string>();
  const [showLtoastMessage, setShowLtoastMessage] = useState<any>(null);
  const [editingCommentId, setEditingCommentId] = useState<string | null>(null); 
  const [replys, Setreplys] = useState<any[]>([]); 
  const tenantId = useSelector((state: any) => state.meetings.profileTenantId);
  const { mutate: addCm } = useAddComment();
  const { mutate: editCm , data: editCmData} = useEditComment();
  const { mutate: delteCm, data: deleteCmData } = useDeleteComment();
  const [editingReplyId, setEditingReplyId] = useState<string | null>(null); 
  const pName = useSelector((state: any) => state.loign.name);
  const personId=useSelector((state:any)=>state.loign.personId);
  const [replyText, setReplyText] = useState<string>(''); 
  const [replyToCommentId, setReplyToCommentId] = useState<string | null>(null);
  const { data: dataComment, isLoading: dataLoading, isError: dataError, refetch: getAgain } = useGetAllCommentById(id,undefined);
  const { data: personPicture, isLoading: loadingg } = useGetAllPersonPictureByTenantId(tenantId);
  const [activeReplyId, setActiveReplyId] = useState<string | null>(null); 

  useEffect(() => {
    if (dataComment !== null && dataComment !== undefined) {
      const newComments: any[] = [];
      dataComment.map((item: any) => {
        newComments.push({ ...item, likeCount: 0, activeBtn: "none" });
      });
      setComments(newComments);
    }
  }, [dataComment]);

   const handleEditReply = (commentId: string, replyId: string, text: string) => {
    setEditingReplyId(replyId);
    setReplyToCommentId(commentId);
    setReplyText(text);
   };

  const handleUpdateReply = (commentId: string, replyId: string) => {
    const updatedReply = {
      id: replyId,
      text: replyText,
      tenantId: tenantId,
      createBy: pName,
      createDate: 'اکنون',
    };
    
    const updatedComments = comments.map(comment => {
      if (comment.id === commentId) {
        const updatedReplies = comment.replies.map((reply: any) => reply.id === replyId ? updatedReply : reply);
        return { ...comment, replies: updatedReplies };
      }
      return comment;
    });
    
    editCm(updatedReply);

    if(editCmData)
      {
        if(editCmData.data.isSuccess){
          setComments(updatedComments);
          setReplyText('');
          setEditingReplyId(null);
          setReplyToCommentId(null);
          setShowLtoastMessage(true);
          SetIsSuccess(true);
          SetTMessage(editCmData?.data.metaData.message);
        }else{
          handleClos();
          setShowLtoastMessage(true);
          SetIsSuccess(false);
          SetTMessage(editCmData?.data.metaData.message);
        }
      }
  };
    const handleDeleteReply = (commentId: string, replyId: string) => {
      const updatedComments = comments.map(comment => {
        if (comment.id === commentId) {
          const updatedReplies = comment.replies.filter((reply: any) => reply.id !== replyId);
          return { ...comment, replies: updatedReplies };
        }
        return comment;
      });
      let deleteBody = {
        commentId: replyId,
        tenantId: tenantId,
      };
      delteCm(deleteBody);

      if(deleteCmData)
        {
          if(deleteCmData.data.isSuccess){
            setComments(updatedComments);
            handleClos();
            setShowLtoastMessage(true);
            SetIsSuccess(true);
            SetTMessage(deleteCmData?.data.metaData.message);
          }else{
            handleClos();
            setShowLtoastMessage(true);
            SetIsSuccess(false);
            SetTMessage(deleteCmData?.data.metaData.message);
          }
        }
    };

  const initialDeleteComment = (idddd: any) => {
    let deleteBody = {
      commentId: idddd,
      tenantId: tenantId,
    };
    delteCm(deleteBody);
  };

  const handleEditComment = (commentId: string, text: string, replies:any[]) => {
    setEditingCommentId(commentId);
    Setreplys(replies);
    setNewComment(text);
  };

  const handleUpdateComment = (commentId: string, replies : any[]) => {
    const updatedComment = {
      id: commentId,
      commentId:id,
      text: newComment,
      tenantId: tenantId,
      createBy: pName,
      personId: personId,
      createDate: 'اکنون',
      replies : replies,
    };
    editCm(updatedComment);
    
    if(editCmData)
      {
        if(editCmData.data.isSuccess){
          setComments(comments.map(comment => comment.id === commentId ? updatedComment : comment));
          setNewComment("");
          setEditingCommentId(null);
          setShowLtoastMessage(true);
          SetIsSuccess(true);
          SetTMessage(editCmData?.data.metaData.message);
        }else{
          handleClos();
          setShowLtoastMessage(true);
          SetIsSuccess(false);
          SetTMessage(editCmData?.data.metaData.message);
        }
      }
  };

  const handleDeleteComment = (iddd: string) => {
    initialDeleteComment(iddd);
    if(deleteCmData)
    {
      if(deleteCmData.data.isSuccess){
        setComments(comments.filter((comment) => comment.id !== iddd));
        handleClos();
        setShowLtoastMessage(true);
        SetIsSuccess(true);
        SetTMessage(deleteCmData?.data.metaData.message);
      }else{
        handleClos();
        setShowLtoastMessage(true);
        SetIsSuccess(false);
        SetTMessage(deleteCmData?.data.metaData.message);
      }
    }
  };

  const handleAddComment = () => {
    if (newComment.trim() === '') return;
    const comment: Comment = {
        commentId: id,
        text: newComment,
        tenantId: tenantId,
        createBy: pName,
        personId: personId,
        meetingId:meetingId,
        createDate: 'اکنون',
        replies: []
    };
    addCm(comment);
    setComments([...comments, { ...comment, likeCount: 0, activeBtn: 'none' }]);
    setNewComment('');
};

const handleReplyComment = (commentId: string) => {
    if (replyText.trim() === '') return;
    const reply: Comment = {
      text: replyText,
        parentId : commentId,
        commentId : id,
        personId: personId,
        tenantId: tenantId,
        createBy: pName,
        meetingId:meetingId,
        createDate: 'اکنون',
        replies: [] 
    };
  //   const handleDeleteComment = (commentId: string) => {
  //     setComments(prevComments => 
  //         prevComments.filter(comment => comment.commentId !== commentId)
  //     );
  // };
  //const handleClickReply = (replyId: string) => {
    //setActiveReplyId(replyId === activeReplyId ? null : replyId); 
  //};
    const updatedComments = comments.map(comment => {
        if (comment.id === commentId) {
            return {
                ...comment,
                replies: [...comment.replies, reply] 
            };
        }
        return comment;
    });
    setComments(updatedComments);
    addCm(reply);
    setReplyText('');
    setReplyToCommentId(null);
};

const [open, setOpen] = React.useState(false);
const theme = useTheme();
const fullScreen = useMediaQuery(theme.breakpoints.down('md'));

const handleClickOpen = () => {
  setOpen(true);
};

const handleClos = () => {
  setOpen(false);
};

const handleClickReply = (replyId: string) => {
  setActiveReplyId(replyId === activeReplyId ? null : replyId);
};

  if (loadingg || dataLoading) {
    return (
      <Grid container>
        <Box width={'100%'} py={5} textAlign={'center'}>
          <CircularProgress color='primary' />
        </Box>
      </Grid>
    );
  }

  return (
    <Grid container padding={3} spacing={2} justifyContent="center">
      <Grid item xs={12}>
        <Box sx={{ backgroundColor: '#ebecf0', padding: '16px', borderRadius: '16px' }}>
          <Typography variant="h6" gutterBottom>
            ثبت نظر برای : {name}
          </Typography>
          <TextField
            label="نظر خود را وارد کنید"
            variant="outlined"
            fullWidth
            value={newComment}
            onChange={(e) => setNewComment(e.target.value)}
            sx={{ mb: 2, backgroundColor: '#fff', borderRadius: '8px' }}
          />
        {/* <Box sx={{ display: 'flex', justifyContent: 'end' }}>
    <Button
        variant="contained"
        color="primary"
        onClick={editingCommentId ? () => handleUpdateComment(editingCommentId, replys) : handleAddComment}
        sx={{ mr: 1 }} 
    >
        {editingCommentId ? "به‌روزرسانی" : "ثبت"}
    </Button>

    {editingCommentId && (
        <Button
            variant="outlined" 
            onClick={() => {
                setNewComment("");
                setEditingCommentId(null);
            }}
            sx={{ opacity: 0.6 }} 
        >
            لغو
        </Button>
    )}
</Box> */}
<Box sx={{ display: 'flex', justifyContent: 'end' }}>
    <Button
        variant="contained"
        color="primary"
        onClick={() => {
            // اگر در حالت ویرایش هستیم، کامنت را به‌روزرسانی کنید
            if (editingCommentId) {
                handleUpdateComment(editingCommentId, replys);
            } else {
                handleAddComment();
            }
            // بعد از عملیات، کادر ورودی را خالی کنید
            setNewComment(""); 
            setEditingCommentId(null); // اگر ویرایش است، حالت ویرایش را غیرفعال کنید
        }}
        sx={{ mr: 1 }}
    >
        {editingCommentId ? "به‌روزرسانی" : "ثبت"}
    </Button>

    {editingCommentId && (
        <Button
            variant="outlined"
            onClick={() => {
                // لغو عملیات ویرایش
                setNewComment(""); // کادر ورودی را خالی کنید
                setEditingCommentId(null); // حالت ویرایش را لغو کنید
            }}
            sx={{ opacity: 0.6 }}
        >
            لغو
        </Button>
    )}
</Box>

        </Box>
      </Grid>
      <Grid item xs={12}>
        <Box width={'100%'} padding={1} minHeight={'20%'}  justifyContent={'start'} px={2}>
          {comments.length > 0 ? (
            comments.map((comment) => (
              <Card key={comment.commentId} sx={{ mb: 1 ,  backgroundColor: '#ebecf0',borderRadius:'16px'}}>
                <CardContent>
                  <Stack  direction="row" justifyContent="space-between" alignItems="start" mb={2}>
                    <Typography variant="caption" color="textSecondary">
                      {comment.createDate}
                    </Typography>
                    <Box >
                    <IconButton
                    onClick={() => handleEditComment(comment.id, comment.text, comment.replies)}    
                    sx={{ color: '#d32f2f' }}
                    >
                    <Tooltip  title="ویرایش">
                    <EditIcon color='primary'   />
                    </Tooltip>

                    </IconButton>
                    <Tooltip  title="حذف">
                      {/* <IconButton  onClick={handleClickOpen}> */}
                      <IconButton  onClick={() => handleDeleteComment(comment.id)}>
                      <DeleteIcon color='error'   />
                    </IconButton>
                    </Tooltip>
                    <Dialog
                      fullScreen={fullScreen}
                      open={open}
                      onClose={handleClos}
                      aria-labelledby="responsive-dialog-title"
                    >
                      <DialogTitle id="responsive-dialog-title" fontWeight={600} fontSize={'17px'}>
                        {"آیا از حذف نظر اطمینان دارید؟"}
                      </DialogTitle>
                      <DialogActions >
                        <Button autoFocus onClick={handleClos} >
                          <Typography  color={'red'}> انصراف</Typography> 
                        </Button>
                        <Button autoFocus  onClick={() => handleDeleteComment(comment.id)} >
                          <Typography  color={'#00387C'} > تایید</Typography> 
                        </Button>
                      </DialogActions>
                    </Dialog>
                    </Box>
                  </Stack>
                  <Stack direction="row" spacing={2} alignItems="center">
                    <Box textAlign={'center'} display={'flex'} alignItems={'center'} flexDirection={'column'}>
                      <img
                        src={personPicture !== null && personPicture !== undefined &&
                          personPicture.filter((x: any) => x.personId === comment.personId)[0] !== null &&
                          personPicture.filter((x: any) => x.personId === comment.personId)[0] !== undefined
                          ?
                          personPicture.filter((x: any) => x.personId === comment.personId)[0].pictureBase64String
                          : ''}
                        width={'60px'} style={{ borderRadius: '50%' }} />
                    </Box>
                    <Box flexGrow={1}>
                      <Typography variant="body1">
                        {comment.createBy}: {comment.text}
                      </Typography>
                    </Box>
                    <Button onClick={() => { setReplyToCommentId(comment.id); setReplyText(''); }} >پاسخ به این نظر</Button>
                  </Stack>
                  {/* نمایش پاسخ‌ها */}
                {comment.replies && comment.replies.length > 0 && (
                  <Box sx={{ maxWidth: '80%', margin: '0 auto', backgroundColor: '#dfe2e6',borderRadius:'16px',padding:1 }}>
                    {comment.replies.map((reply: any) => (
                      <Stack direction="row" alignItems="center" key={reply.commentId} sx={{ mb: 0.5 }}>
                        <Box sx={{ flexGrow: 1, display: 'flex', alignItems: 'center' }}
                        onClick={() => handleClickReply(reply.id)}
                        >
                        <Box textAlign={'center'} display={'flex'} alignItems={'center'} flexDirection={'column'}>
                      <img
                        src={personPicture !== null && personPicture !== undefined &&
                          personPicture.filter((x: any) => x.personId === reply.personId)[0] !== null &&
                          personPicture.filter((x: any) => x.personId === reply.personId)[0] !== undefined
                          ?
                          personPicture.filter((x: any) => x.personId === reply.personId)[0].pictureBase64String
                          : ''}
                        width={'60px'} style={{ borderRadius: '50%' }} />
                    </Box>
                        <Typography
                              variant="body2"
                              sx={{ padding: '2px 6px', borderRadius: '4px', fontSize: '12px' }}
                            >
                            {reply.createBy}: {reply.text}
                          </Typography>
                        </Box>
                        {activeReplyId === reply.id && (
                            <>
                              <IconButton
                                size="small"
                                onClick={() => handleEditReply(comment.id, reply.id, reply.text)}
                                sx={{ padding: '4px' }}
                              >
                                <EditIcon color="primary" fontSize="small" />
                              </IconButton>
                              <IconButton
                                size="small"
                                onClick={() => handleDeleteReply(comment.id, reply.id)}
                                sx={{ padding: '4px' }}
                              >
                                <DeleteIcon color="error" fontSize="small" />
                              </IconButton>
                            </>
                          )}
                        </Stack>
                      ))}
                  </Box>
                )}
                  {replyToCommentId === comment.id && (
                    <Box sx={{ mt: 2, pl: 4 }}>
                      <TextField
                        label="پاسخ خود را وارد کنید"
                        variant="outlined"
                        fullWidth
                        value={replyText}
                        onChange={(e) => setReplyText(e.target.value)}
                      />
                      <Box sx={{ display: 'flex', justifyContent: 'end', mt: 2 }}>
                        <Button
                          variant="contained"
                          onClick={editingReplyId ? () => handleUpdateReply(comment.id, editingReplyId) : () => handleReplyComment(comment.id)}
                          sx={{ mr: 1 }}
                        >
                          {editingReplyId ? "به‌روزرسانی پاسخ" : "ارسال پاسخ"}
                        </Button>
                        <Button
                          variant="outlined"
                          onClick={() => {
                            setReplyText('');
                            setReplyToCommentId(null);
                            setEditingReplyId(null);
                          }}
                        >
                          لغو
                        </Button>
                  </Box>
              </Box>
          )}
                </CardContent>
              </Card>
            ))
          ) : (
            <Typography align="center" color="textSecondary">
              نظری ثبت نشده است.
            </Typography>
          )}
        </Box>
      </Grid>
      {showLtoastMessage && (
          <DYToastMessage
            isSuccess={isSucces}
            message={tMessage}
            setShow={setShowLtoastMessage}
            show={showLtoastMessage}
          />
        )}
    </Grid>
  );
};

export default CommentSection;
